"use client"
import { useState, useEffect } from "react"
import axios from "axios"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllVendorProduct = () => {
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [previewImage, setPreviewImage] = useState(null)

  const [searchTerm, setSearchTerm] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  // edit cost price
  const [editProduct, setEditProduct] = useState(null);
  const [newCostPrice, setNewCostPrice] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);


  useEffect(() => {
    fetchProducts()
  }, [])

  const fetchProducts = async () => {
    try {
      setIsLoading(true)
      const res = await axios.get(
        `https://logicx.premierlam.com/api/get-pixel-products-for-vendor`,
        { headers: { authorization: localStorage.getItem("accessToken") } }
      )
      setProducts(res.data.data || [])
    } catch (err) {
      setError("Token expired. Please login again.")
      setProducts([]) // empty UI but not breaking
    } finally {
      setIsLoading(false)
    }
  }

  const filteredProducts = products.filter(
    (p) =>
      p.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.product_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.category_name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  const totalPages = Math.ceil(filteredProducts.length / rowsPerPage)
  const paginatedProducts = filteredProducts.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  )

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })
  const updateCostPrice = async () => {
    if (!editProduct) return;

    try {
      setIsUpdating(true);

      await axios.put(
        `https://logicx.premierlam.com/api/update-pixel-cost-price-of-products-for-vendor/${editProduct.product_code}`,
        { product_cost_price: newCostPrice },
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );

      alert("Cost price updated successfully!");
      setEditProduct(null);
      setNewCostPrice("");
      fetchProducts(); // refresh
      toast.success("Cost Price Updated successfully!");

    } catch (err) {
      alert("Error updating cost price");
      toast.success("Cost Price Not updated successfully!");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="p-4 bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">Vendor Products</h1>
            <p className="text-gray-500">All products assigned to this vendor</p>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none w-64 mb-4"
            />

            {error && (
              <div className="mb-3 p-3 bg-red-100 border border-red-300 rounded text-red-700 font-medium">
                {error}
              </div>
            )}

            {/* TABLE */}
            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6 text-gray-500">Loading...</div>
              ) : (
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="border-b border-gray-200 text-gray-600 text-sm">
                      <th className="py-3 px-4 text-left">Image</th>
                      <th className="py-3 px-4 text-left">Code</th>
                      <th className="py-3 px-4 text-left">Description</th>
                      <th className="py-3 px-4 text-left">Name</th>

                      <th className="py-3 px-4 text-left">Material</th>
                      <th className="py-3 px-4 text-left">Cost Price</th>




                    </tr>
                  </thead>

                  <tbody>
                    {paginatedProducts.map((p) => (
                      <tr key={p.id} className="border-b hover:bg-gray-50">
                        <td className="py-3 px-4">
                          <img
                            src={p.product_image}
                            className="w-12 h-12 rounded cursor-pointer"
                            onClick={() => setPreviewImage(p.product_image)}
                          />
                        </td>
                        <td className="py-3 px-4 text-sm">{p.product_code}</td>
                        <td className="py-3 px-4 text-sm">{p.product_description}</td>
                        <td className="py-3 px-4 text-sm">{p.product_name}</td>

                        <td className="py-3 px-4 text-sm">{p.product_material}</td>
                        <td className="py-3 px-4 text-sm  gap-2">
                          <span className="text-green-600 font-bold flex items-center">
                            ₹{p.product_cost_price}
                        

                          {p.updated_cost_price_status === false && (
                            <button
                              className="ml-2 text-blue-600 underline text-xs  flex items-center h-full"
                              onClick={() => {
                                setEditProduct(p);
                                setNewCostPrice(p.product_cost_price);
                              }}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                /> </svg>
                            </button>
                          )}
                            </span>
                        </td>





                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {/* pagination */}
            <div className="flex justify-between items-center mt-4 text-sm text-gray-600">
              <span>Page {currentPage} of {totalPages}</span>
              <div className="flex gap-2">
                <button
                  onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-3 py-1 border rounded-md disabled:opacity-50"
                >
                  Prev
                </button>
                <button
                  onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 border rounded-md disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* IMAGE PREVIEW */}
        {previewImage && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
            <div className="bg-white p-4 rounded-lg max-w-2xl w-full relative">
              <button
                className="absolute top-3 right-3 text-gray-600 hover:text-black"
                onClick={() => setPreviewImage(null)}
              >
                ✖
              </button>

              <img src={previewImage} className="w-full object-contain max-h-[70vh]" />

              <div className="flex justify-end mt-4">
                <a
                  href={previewImage}
                  download
                  className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
                >
                  Download
                </a>
              </div>
            </div>
          </div>
        )}
        {/* edit cost price  */}
        {editProduct && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-80 shadow-lg relative">

              <h2 className="text-lg font-semibold mb-3">
                Update Cost Price
              </h2>

              <p className="text-sm text-gray-600 mb-2">
                Product: <b>{editProduct.product_name}</b>
              </p>

              <input
                type="number"
                value={newCostPrice}
                onChange={(e) => setNewCostPrice(e.target.value)}
                className="w-full border p-2 rounded mb-4"
                placeholder="Enter new cost price"
              />

              <div className="flex justify-end gap-3">
                <button
                  className="px-4 py-2 bg-gray-200 rounded"
                  onClick={() => setEditProduct(null)}
                >
                  Cancel
                </button>

                <button
                  className="px-4 py-2 bg-orange-500 text-white rounded"
                  onClick={updateCostPrice}
                  disabled={isUpdating}
                >
                  {isUpdating ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  )
}

export default AllVendorProduct
